/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualWorkingCapitalDto } from '../../models/backend-actual-working-capital-dto';
import { BackendActualWorkingCapitalRequestDto } from '../../models/backend-actual-working-capital-request-dto';

export interface MonitoringActualsWorkingCapitalUpdate$Params {
  id: number;
  body: BackendActualWorkingCapitalRequestDto;
}

export function monitoringActualsWorkingCapitalUpdate(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringActualsWorkingCapitalUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendActualWorkingCapitalDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsWorkingCapitalUpdate.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendActualWorkingCapitalDto>;
    }),
  );
}

monitoringActualsWorkingCapitalUpdate.PATH = '/api/monitoring/actuals/working-capital/{id}/';
